module.exports = __webpack_public_path__ + "img/multiple-actions-edit-2.dbf0a824.svg";